export default __webpack_public_path__ + "static/media/SE-Life-is-On.0e9c3941.png";